import { call, put } from '@redux-saga/core/effects';
import CryptoES from 'crypto-es';

import { logIn } from '@api/auth';
import { verifyCode } from '@api/inviteUser';
import { getUserAccount } from '@api/user';
import { setUser } from '@helpers/user';
import accountModel from '@models/Account';
import { userModel } from '@models/User';
import { history } from '@routes/history';
import { vsuiteRoutes } from '@routes/vsuite';
import { resetInviteRequest } from '@store/inviteUser/signUp/signUp.actions';
import { toastError } from '@store/notifications';
import { userGetSuccessAction } from '@store/user/user.actions';

export const verifyOtpSaga = function* ({ payload }) {
  try {
    const { email, code, password, isTwoFactorSetup, returnTo } = payload;
    let verifyResponse;

    if (isTwoFactorSetup) {
      verifyResponse = yield call(verifyCode, { email, otp: code });
    } else {
      const hashedPassword = password
        ? CryptoES.SHA512(password).toString(CryptoES.enc.Hex)
        : undefined;
      verifyResponse = yield call(logIn, email, hashedPassword, code);
    }

    const { token, refresh, user } = isTwoFactorSetup ? verifyResponse.login : verifyResponse;
    const { account, id } = user;

    yield call(setUser, { token, refresh, id });

    const accountResponse = yield call(getUserAccount, account);

    yield put([
      resetInviteRequest(),
      userGetSuccessAction({
        ...userModel(user),
        account: accountModel(accountResponse),
      }),
    ]);

    yield call(history.replace, returnTo || vsuiteRoutes.DASHBOARD.make());
  } catch (errors) {
    const { nonFieldErrors, hasFieldError, fieldErrors } = errors?.data || {};

    if (hasFieldError) {
      yield call(payload.setErrors, fieldErrors);
    }

    yield put(
      toastError({
        message: nonFieldErrors || {
          defaultMessage: 'Mobile number verification failed.',
          id: 'components.verify-otp-form.verify-mobile-failed',
        },
      })
    );

    yield call(payload.setSubmitting, false);
  }
};
